import { useAtom } from 'jotai'
import styled from 'styled-components'
import { rControlsVisibilityAtom } from './atoms'

/*======================== React component ===================================*/

const ShadowBackground = (): JSX.Element => {
  const [controlsVisible] = useAtom(rControlsVisibilityAtom)

  return <Shadow isVisible={controlsVisible} />
}

export default ShadowBackground

/*======================== Styled components =================================*/

const Shadow = styled.div<{ isVisible: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // Add a black gradient which fills 30% of the screen height from the bottom
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.3) 30%,
    rgba(0, 0, 0, 0) 100%
  );
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
`
